import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaskDateHourDirective } from './directives/maskDateHour.directive';
import { OnlyPositiveDirective } from './directives/only-positive.directive';

import {
    ClienteAutocompleteComponent,
    ImpressorasAutoCompleteComponent,
    ModalSelecaoVolumesComponent,
    ModalLoginManifestoComponent,
    ModalAreaTransferenciaComponent,
    ModalManifestoEmbarquePainelDetalheComponent,
    ModalManifestoDetalhesEmbarqueComponent,
    ManifestoTransferenciaGridVolumesComponent,
    RecepcaoGridVolumesComponent,
    ModalEstadoComponent,
    MatSelectSearchComponent, ModalConfirmacaoComponent,
    ModalMensagemComponent, PaginacaoComponent, RastreamentoFooterComponent, InputPesquisaClienteComponent,
    TabDirective, ChipAutocompleteComponent, AutoFocusDirective, CustomTooltipDirective,
    ExternalLinkDirective, MaskDateDirective, NumericDirective, SomenteNumerosDirective, ImageDirective, PasswordMeterComponent, DisableControlDirective
} from './';
import { SharedModule } from '../shared.module';
import { LoadingDirective } from './directives/loading.directive';
import { ModalErroComponent } from 'src/app/@feature/consultas/consultas/log-status-api-intelipost/modal-erro/modal-erro.component';
import { ModalErroColetorComponent } from './modal-erro-coletor/modal-erro-coletor.component';
import { ModalSucessoColetorComponent } from './modal-sucesso-coletor/modal-sucesso-coletor.component';
import { ModalImpressaoComponent } from './modal-impressao/modal-impressao.component';
import { CampoDropdownComponent } from './campo-dropdown/campo-dropdown.component';
import { ModalSelecaoManifestoComponent } from './modal-selecao-manifesto/modal-selecao-manifesto.component';
import { ModalSelecaoValoresColetorComponent } from './modal-selecao-valores-coletor/modal-selecao-valores-coletor.component';
import { ModalDetalhesColetorComponent } from './modal-detalhes-coletor/modal-detalhes-coletor.component';
import { DetalhesMapaDeCarregamentoDesenhoComponent } from 'src/app/@feature/manifesto-embarque/manifesto-embarque/mapa-de-carregamento/mapa-de-carregamento-desenho/detalhes-mapa-de-carregamento-desenho/detalhes-mapa-de-carregamento-desenho.component';
import { TabelaMapaDeCarregamentoDesenhoComponent } from 'src/app/@feature/manifesto-embarque/manifesto-embarque/mapa-de-carregamento/mapa-de-carregamento-desenho/tabela-mapa-de-carregamento-desenho/tabela-mapa-de-carregamento-desenho.component';
import { ModalConsultaLogsComponent } from './modal-consulta-logs/modal-consulta-logs.component';
import { ModalDetalheLogComponent } from './modal-consulta-logs/modal-detalhe-log/modal-detalhe-log.component';
import { JsonArvoreComponent } from './modal-consulta-logs/json-arvore/json-arvore.component';
import { RadioCardComponent } from './radio-card/radio-card.component';
import { BotaoDinamicoComponent } from './botao-clique-unico/botao-dinamico.component';

@NgModule({
    imports: [
        CommonModule, 
        SharedModule
    ],
    declarations: [
        ClienteAutocompleteComponent,
        ImpressorasAutoCompleteComponent,
        ModalSelecaoVolumesComponent,
        ModalLoginManifestoComponent,
        ModalAreaTransferenciaComponent,
        ModalManifestoEmbarquePainelDetalheComponent,
        ModalManifestoDetalhesEmbarqueComponent,
        ManifestoTransferenciaGridVolumesComponent,
        RecepcaoGridVolumesComponent,
        ModalEstadoComponent,
        MatSelectSearchComponent, 
        ModalConfirmacaoComponent,
        ModalMensagemComponent, 
        PaginacaoComponent, 
        RastreamentoFooterComponent, 
        InputPesquisaClienteComponent,
        TabDirective, 
        ChipAutocompleteComponent, 
        AutoFocusDirective, 
        CustomTooltipDirective,
        ExternalLinkDirective, 
        MaskDateDirective, 
        NumericDirective, 
        SomenteNumerosDirective, 
        DisableControlDirective,
        LoadingDirective,
        ExternalLinkDirective, 
        MaskDateDirective, 
        NumericDirective, 
        SomenteNumerosDirective,
        LoadingDirective, 
        ImageDirective,
        MaskDateHourDirective, 
        OnlyPositiveDirective,
        CampoDropdownComponent,
        ModalSelecaoManifestoComponent,
        ModalSelecaoValoresColetorComponent, 
        ModalDetalhesColetorComponent,
        TabelaMapaDeCarregamentoDesenhoComponent,
        DetalhesMapaDeCarregamentoDesenhoComponent,
        ModalErroColetorComponent, 
        ModalSucessoColetorComponent, 
        ModalImpressaoComponent, 
        ModalConsultaLogsComponent, 
        ModalDetalheLogComponent, 
        JsonArvoreComponent,
        ModalErroColetorComponent, 
        ModalSucessoColetorComponent, 
        ModalImpressaoComponent, 
        PasswordMeterComponent,
        RadioCardComponent,
        BotaoDinamicoComponent,
    ],
    exports: [
        CommonModule, 
        ClienteAutocompleteComponent,
        ImpressorasAutoCompleteComponent,
        ModalErroColetorComponent, 
        ModalSucessoColetorComponent, 
        ModalImpressaoComponent, 
        ModalConsultaLogsComponent, 
        ModalDetalheLogComponent, 
        JsonArvoreComponent,
        ModalErroColetorComponent, 
        ModalSucessoColetorComponent, 
        ModalImpressaoComponent, 
        PasswordMeterComponent, 
        BotaoDinamicoComponent,
        CommonModule, 
        ClienteAutocompleteComponent,
        ImpressorasAutoCompleteComponent,
        ModalSelecaoVolumesComponent,
        ModalLoginManifestoComponent,
        ModalAreaTransferenciaComponent,
        ModalManifestoEmbarquePainelDetalheComponent,
        ModalManifestoDetalhesEmbarqueComponent,
        ManifestoTransferenciaGridVolumesComponent,
        RecepcaoGridVolumesComponent,
        ModalEstadoComponent,
        MatSelectSearchComponent, 
        ModalConfirmacaoComponent,
        ModalMensagemComponent, 
        PaginacaoComponent, 
        RastreamentoFooterComponent, 
        InputPesquisaClienteComponent,
        TabDirective, 
        ChipAutocompleteComponent, 
        AutoFocusDirective, 
        CustomTooltipDirective,
        ExternalLinkDirective, 
        MaskDateDirective, 
        NumericDirective, 
        SomenteNumerosDirective, 
        DisableControlDirective,
        LoadingDirective,
        ExternalLinkDirective, 
        MaskDateDirective, 
        NumericDirective, 
        SomenteNumerosDirective,
        LoadingDirective, 
        ImageDirective,
        MaskDateHourDirective, 
        OnlyPositiveDirective,
        ModalErroColetorComponent, 
        ModalSucessoColetorComponent, 
        CampoDropdownComponent,
        ModalSelecaoManifestoComponent,
        TabelaMapaDeCarregamentoDesenhoComponent,
        DetalhesMapaDeCarregamentoDesenhoComponent,
        ModalConsultaLogsComponent,
        DetalhesMapaDeCarregamentoDesenhoComponent, 
        PasswordMeterComponent,
        RadioCardComponent,
        DetalhesMapaDeCarregamentoDesenhoComponent, 
    ],
    providers: []
})
export class ComponentsModule {

}
